import BasePage from '../../components/base-page/base-page';
import BlogSearch from '../../components/search/search';
import Share from '../../../shared/utils/share/share';
import SideScrollingBanner from '../../components/side-scrolling-banner/side-scrolling-banner';
import defineBlogAppBannerElement from '../../components/blog-app-banner/blog-app-banner';
import GoUpButton from '../../components/go-up-button/go-up-button';
import WebAssistantModal from '../../components/web-assistant-modal/web-assistant-modal';
import WebAssistantInput from '../../components/web-assistant-input/web-assistant-input';

import analytics, { events } from '../../../shared/analytics';

import './post.scss';

class PostPage extends BasePage {
  webAssistantModal;

  ui = {
    articleTitle: '.js-article-title',
    searchInput: '.js-search-input',
    assistantForm: '.js-assistant-form',
    openAssistantButton: '.js-open-assistant-modal',
    webAssistantModalElem: '#web-assistant-modal',
  }

  uiCollections = {
    contentBannerButton: '.js-promo-banner-cta',
    appBannerButton: 'blog-app-banner',
    useCaseBannerLink: '.use-case-banner a', // choose all links inside use-case-banner that's created on blog
  }

  events = {
    'click @uiCollections.contentBannerButton': 'handleContentBannerButtonClick',
    'click @uiCollections.appBannerButton': 'handleAppBannerButtonClick',
    'click @uiCollections.useCaseBannerLink': 'handleUseCaseBannerLinkClick',
    'click @ui.openAssistantButton': 'handleOpenAssistantButtonClick',
  }

  onInit() {
    super.onInit();

    if (this.ui.searchInput) {
      new BlogSearch().init();
    }
    new Share().init();
    new SideScrollingBanner().init();
    new GoUpButton(this.ui.articleTitle).init();

    if (this.ui.webAssistantModalElem) {
      this.webAssistantModal = new WebAssistantModal();
      this.webAssistantModal.init();
    }

    if (this.ui.assistantForm) {
      new WebAssistantInput('.article', this.handleAssistantFormSubmit).init();
    }

    defineBlogAppBannerElement();
  }

  handleContentBannerButtonClick = (e) => {
    e.preventDefault();
    const { textContent: eventLabel } = e.target.closest('.promo-banner')?.querySelector('.promo-banner__description-header');

    this.signupModal.open();

    analytics.trackEvent({
      ...events.BLOG_BANNER_CLICK,
      eventLabel,
      eventLabel2: 'promo-banner',
    });
  }

  handleAppBannerButtonClick = (e) => {
    const eventLabel = e.currentTarget.getAttribute('name');

    analytics.trackEvent({
      ...events.BLOG_BANNER_CLICK,
      eventLabel,
      eventLabel2: 'app-banner',
    });
  }

  handleUseCaseBannerLinkClick = (e) => {
    const { textContent: eventLabel } = e.currentTarget;

    analytics.trackEvent({
      ...events.BLOG_BANNER_CLICK,
      eventLabel,
      eventLabel2: 'use-case-banner',
    });
  }

  handleAssistantFormSubmit = (value) => {
    this.webAssistantModal.open({ value });
  };

  handleOpenAssistantButtonClick = (e) => {
    e.preventDefault();

    analytics.trackEvent({
      ...events.WEB_ASSISTANT_OPEN,
      eventLabel: 'Side',
    });

    this.webAssistantModal.open();
  }
}

export default PostPage;

PostPage.initOnDomLoaded();
